// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/delete_reference_image.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/delete_reference_image.proto.
 */
export const file_vision_assets_v1_delete_reference_image: GenFile = /*@__PURE__*/
  fileDesc("Ci12aXNpb24vYXNzZXRzL3YxL2RlbGV0ZV9yZWZlcmVuY2VfaW1hZ2UucHJvdG8SF3Byb3Rvcy52aXNpb24uYXNzZXRzLnYxIpoBChtEZWxldGVSZWZlcmVuY2VJbWFnZVJlcXVlc3QSSwoGcGFyYW1zGAEgASgLMjsucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuRGVsZXRlUmVmZXJlbmNlSW1hZ2VSZXF1ZXN0LlBhcmFtcxouCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRIQCghhc3NldF9pZBgCIAEoCSJ2ChxEZWxldGVSZWZlcmVuY2VJbWFnZVJlc3BvbnNlEkwKBnJlc3VsdBgBIAEoCzI8LnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLkRlbGV0ZVJlZmVyZW5jZUltYWdlUmVzcG9uc2UuUmVzdWx0GggKBlJlc3VsdGIGcHJvdG8z");

/**
 * @generated from message protos.vision.assets.v1.DeleteReferenceImageRequest
 */
export type DeleteReferenceImageRequest = Message<"protos.vision.assets.v1.DeleteReferenceImageRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.DeleteReferenceImageRequest.Params params = 1;
   */
  params?: DeleteReferenceImageRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.DeleteReferenceImageRequest.
 * Use `create(DeleteReferenceImageRequestSchema)` to create a new message.
 */
export const DeleteReferenceImageRequestSchema: GenMessage<DeleteReferenceImageRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_reference_image, 0);

/**
 * @generated from message protos.vision.assets.v1.DeleteReferenceImageRequest.Params
 */
export type DeleteReferenceImageRequest_Params = Message<"protos.vision.assets.v1.DeleteReferenceImageRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string asset_id = 2;
   */
  assetId: string;
};

/**
 * Describes the message protos.vision.assets.v1.DeleteReferenceImageRequest.Params.
 * Use `create(DeleteReferenceImageRequest_ParamsSchema)` to create a new message.
 */
export const DeleteReferenceImageRequest_ParamsSchema: GenMessage<DeleteReferenceImageRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_reference_image, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.DeleteReferenceImageResponse
 */
export type DeleteReferenceImageResponse = Message<"protos.vision.assets.v1.DeleteReferenceImageResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.DeleteReferenceImageResponse.Result result = 1;
   */
  result?: DeleteReferenceImageResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.DeleteReferenceImageResponse.
 * Use `create(DeleteReferenceImageResponseSchema)` to create a new message.
 */
export const DeleteReferenceImageResponseSchema: GenMessage<DeleteReferenceImageResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_reference_image, 1);

/**
 * @generated from message protos.vision.assets.v1.DeleteReferenceImageResponse.Result
 */
export type DeleteReferenceImageResponse_Result = Message<"protos.vision.assets.v1.DeleteReferenceImageResponse.Result"> & {
};

/**
 * Describes the message protos.vision.assets.v1.DeleteReferenceImageResponse.Result.
 * Use `create(DeleteReferenceImageResponse_ResultSchema)` to create a new message.
 */
export const DeleteReferenceImageResponse_ResultSchema: GenMessage<DeleteReferenceImageResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_reference_image, 1, 0);

